/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询视频详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  videoId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cloundtheater.VideoInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cloundtheater/video/${videoId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
